var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedWarn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2B03A5B6-93BC-414C-B818-1C146B182BDE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Duplicates-Provided--Error",
    transform: "translate(-786.000000, -1192.000000)",
    stroke: "#B81D1D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(786.999508, 1193.476516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(5.488201, 2.532824)",
    fill: "#E54646",
    fillRule: "nonzero",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.92469903,5.16743576 L0.098898292,5.16743576 L0.0346144022,0 L0.993927835,0 L0.92469903,5.16743576 Z M0,6.7399186 C0,6.59157116 0.0453283838,6.46712415 0.135985152,6.36657755 C0.226641919,6.26603095 0.360978766,6.21575765 0.538995692,6.21575765 C0.717012617,6.21575765 0.852173616,6.26603095 0.944478689,6.36657755 C1.03678376,6.46712415 1.0829363,6.59157116 1.0829363,6.7399186 C1.0829363,6.88826604 1.03678376,7.01106475 0.944478689,7.10831474 C0.852173616,7.20556473 0.717012617,7.25418972 0.538995692,7.25418972 C0.360978766,7.25418972 0.226641919,7.20556473 0.135985152,7.10831474 C0.0453283838,7.01106475 0,6.88826604 0,6.7399186 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarn);
export default __webpack_public_path__ + "static/media/red-warn.ddea41c1c11792532a2b5a4c2636d082.svg";
export { ForwardRef as ReactComponent };